// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_m3-1";
export var rowFirst = "_m3-3";
export var rowLast = "_m3-5";
export var rowMiddle = "_m3-4";
export var ticketListScroll = "_m3-2";
export var ticketStack = "_m3-0";